import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';
import {AccordionComponent} from '@shared/container/accordion/accordion.component';
import {AccordionItemComponent} from '@shared/container/accordion/accordion-item/accordion-item.component';

@Component({
  selector: 'app-public-faq',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    AccordionComponent,
    AccordionItemComponent,
    RouterLink
  ],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {

  public readonly routes = {
    contact: RouteGenerator.abs(UI_ROUTES.public.contact)
  };
}
